import type { AdaptiveStatus } from '../api/client'

/**
 * The single honest word for the adaptive loop's mode.
 *
 * `status.mode` alone is NOT safe to render. ADAPTIVE_TUNING_MODE is set on the
 * adaptive-eval ECS task definition only, so the API container never receives
 * it and falls back to the "off" field default — the dashboard displayed
 * "ADAPTIVE: OFF" for a loop that was actually running in "full". The API now
 * says whether its own value is real (`mode_is_authoritative`) and what
 * recorded runs prove (`mode_observed`).
 *
 * Returns the configured mode when authoritative, else 'OFF' (a run proved the
 * worker's off-gate fired), 'RUNNING' (a run got past that gate), or 'UNKNOWN'
 * (nothing recorded yet — never a guess).
 *
 * Deliberately lives outside api/client so component tests that partially
 * `vi.mock` the API module do not have to stub it.
 */
export function adaptiveModeWord(status: AdaptiveStatus): string {
  if (status.mode_is_authoritative) return String(status.mode).toUpperCase()
  if (status.mode_observed === 'off') return 'OFF'
  if (status.mode_observed === 'not_off') return 'RUNNING'
  return 'UNKNOWN'
}
